import { render, staticRenderFns } from "./AscCustomAlertsContainer.vue?vue&type=template&id=bdaecc62&"
import script from "./AscCustomAlertsContainer.vue?vue&type=script&lang=js&"
export * from "./AscCustomAlertsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AscCustomAlertsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
